(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[345],{

/***/ 719:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/products",
      function () {
        return __webpack_require__(5811);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 7809:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/icon-play-circle.86a33328.svg","height":36,"width":36});

/***/ }),

/***/ 7719:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/image-bank-api.94ed5642.png","height":212,"width":478,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAYAAACzzX7wAAAAhUlEQVR42mNkkJ2rycDHZMRwNXGpSfBym3//GBjOrY88wiA1N4qBjfEiY0Xrjgviwpz6hRmnI1dtcJ7JCASh/utSJ8xwXnH/6ZdLLG/e/7zx588/VQaG7/d//Pxzk5GRgZGB4deDL99+f/37998NBiBgZmCoFGMAAiAtwcBQLgFhF4DEmAHLMTGHhzqRXAAAAABJRU5ErkJggg=="});

/***/ }),

/***/ 3050:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/image-neobank-sdk.4cdef311.png","height":294,"width":491,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAYAAAB4ka1VAAAAnElEQVR42mOwC12mERq9aLa233J9Bsu1gsYByyaFRC3apey7PJcBBKSs5wqHRi5YwMC/icMxZEm3c8iSJ66hS74zeK5MYACBGQuOe+TU7JjGYLc0NSZuYXxA5KJ5IPGs5Lke2clzBRmyKrdsSCradE3RfYkBAwi4rZIDUcXps73Tk+ZJM+RVb52QW72tHyRYWbyEGUQnxM9nZoACAEUINBhXmd4eAAAAAElFTkSuQmCC"});

/***/ }),

/***/ 4881:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/logo-digibank.ff1a1b85.png","height":162,"width":471,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAYAAACuyE5IAAAAbklEQVR4nGMMcVfm+Pydk4WXh+ePgjTn3ws3v7GdvP31u7IoIzMTE/MfxuRgRa8X79gUn77jeSbEx8zw5dsfid9//r9mZGQQYGFh2czo5aDOzsPN9X/VVrZ/3LJ/mBQFmRmE+FgZGBiYGIAK/gAAQ5AhEp5UgzgAAAAASUVORK5CYII="});

/***/ }),

/***/ 1500:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/logo-101pay.3fb23a97.png","height":185,"width":369,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAYAAACzzX7wAAAAYElEQVR42mNIUDrP7iZ1iZOB4T+HueZUfjZjBjYGZBAmd0ksQfls9GSToy1uWvMmMBhqpivpx8TI6of6ALEAA1An0yKbLSa3groC1ZRXmooZMygo6kc5AyWDgJiVgRAAAH7PF9+zaBGbAAAAAElFTkSuQmCC"});

/***/ }),

/***/ 4314:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ ModalWatchVideo_ModalWatchVideo; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/media-query/dist/esm/use-media-query.js
var use_media_query = __webpack_require__(1768);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/modal/dist/esm/modal.js + 67 modules
var modal = __webpack_require__(3874);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/esm/box.js
var box = __webpack_require__(8017);
;// CONCATENATED MODULE: ./src/containers/ModalWatchVideo/ModalWatchVideo.tsx



function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {
        };
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {
    };
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {
    };
    var target = {
    };
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}
var ModalWatchVideo = function(_param) {
    var src = _param.src, otherProps = _objectWithoutProperties(_param, [
        "src"
    ]);
    var ref = _slicedToArray((0,use_media_query/* useMediaQuery */.a)("(min-width: 1024px)"), 1), isDesktop = ref[0];
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(modal/* Modal */.u_, _objectSpread({
    }, otherProps, {
        isCentered: !isDesktop,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* ModalOverlay */.ZA, {
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(modal/* ModalContent */.hz, {
                maxW: [
                    "90vw",
                    null,
                    null,
                    null,
                    null,
                    "980px"
                ],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* ModalCloseButton */.ol, {
                        zIndex: 2,
                        top: 0,
                        right: 0,
                        background: "#fff",
                        borderRadius: "50%",
                        transform: "translate(50%, -50%)",
                        _hover: {
                            background: "#fff"
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(box/* Box */.xu, {
                        pos: "relative",
                        height: "100vh",
                        maxH: [
                            "60vw",
                            null,
                            null,
                            null,
                            null,
                            "650px"
                        ],
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                            width: "100%",
                            height: "100%",
                            src: src,
                            frameBorder: "0"
                        })
                    })
                ]
            })
        ]
    })));
};
/* harmony default export */ var ModalWatchVideo_ModalWatchVideo = (ModalWatchVideo);

;// CONCATENATED MODULE: ./src/containers/ModalWatchVideo/index.ts



/***/ }),

/***/ 5811:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ products; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/icon/dist/esm/icon.js
var icon = __webpack_require__(58);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/system/dist/esm/forward-ref.js
var forward_ref = __webpack_require__(63);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/system/dist/esm/use-style-config.js + 1 modules
var use_style_config = __webpack_require__(3793);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/system/dist/esm/system.utils.js
var system_utils = __webpack_require__(5284);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/system/dist/esm/providers.js
var providers = __webpack_require__(9676);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/system/dist/esm/system.js + 4 modules
var system = __webpack_require__(1440);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/utils/dist/esm/assertion.js
var assertion = __webpack_require__(3808);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/react-utils/dist/esm/children.js
var esm_children = __webpack_require__(4255);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./node_modules/@chakra-ui/layout/dist/esm/list.js
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }







/**
 * List is used to display list items, it renders a `<ul>` by default.
 *
 * @see Docs https://chakra-ui.com/list
 */
var List = /*#__PURE__*/(0,forward_ref/* forwardRef */.G)((props, ref) => {
  var styles = (0,use_style_config/* useMultiStyleConfig */.j)("List", props);

  var _omitThemingProps = (0,system_utils/* omitThemingProps */.Lr)(props),
      {
    children,
    styleType = "none",
    stylePosition,
    spacing
  } = _omitThemingProps,
      rest = _objectWithoutPropertiesLoose(_omitThemingProps, ["children", "styleType", "stylePosition", "spacing"]);

  var validChildren = (0,esm_children/* getValidChildren */.W)(children);
  var selector = "& > *:not(style) ~ *:not(style)";
  var spacingStyle = spacing ? {
    [selector]: {
      mt: spacing
    }
  } : {};
  return /*#__PURE__*/react.createElement(providers/* StylesProvider */.Fo, {
    value: styles
  }, /*#__PURE__*/react.createElement(system/* chakra.ul */.m$.ul, _extends({
    ref: ref,
    listStyleType: styleType,
    listStylePosition: stylePosition
    /**
     * We added this role to fix the Safari accessibility issue with list-style-type: none
     * @see https://www.scottohara.me/blog/2019/01/12/lists-and-safari.html
     */
    ,
    role: "list",
    __css: _extends({}, styles.container, spacingStyle)
  }, rest), validChildren));
});

if (assertion/* __DEV__ */.Ts) {
  List.displayName = "List";
}

var OrderedList = /*#__PURE__*/(0,forward_ref/* forwardRef */.G)((props, ref) => {
  var rest = _objectWithoutPropertiesLoose(props, ["as"]);

  return /*#__PURE__*/react.createElement(List, _extends({
    ref: ref,
    as: "ol",
    styleType: "decimal",
    marginStart: "1em"
  }, rest));
});

if (assertion/* __DEV__ */.Ts) {
  OrderedList.displayName = "OrderedList";
}

var UnorderedList = /*#__PURE__*/(0,forward_ref/* forwardRef */.G)((props, ref) => {
  var rest = _objectWithoutPropertiesLoose(props, ["as"]);

  return /*#__PURE__*/react.createElement(List, _extends({
    ref: ref,
    as: "ul",
    styleType: "initial",
    marginStart: "1em"
  }, rest));
});

if (assertion/* __DEV__ */.Ts) {
  UnorderedList.displayName = "UnorderedList";
}

/**
 * ListItem
 *
 * Used to render a list item
 */
var ListItem = /*#__PURE__*/(0,forward_ref/* forwardRef */.G)((props, ref) => {
  var styles = (0,providers/* useStyles */.yK)();
  return /*#__PURE__*/react.createElement(system/* chakra.li */.m$.li, _extends({
    ref: ref
  }, props, {
    __css: styles.item
  }));
});

if (assertion/* __DEV__ */.Ts) {
  ListItem.displayName = "ListItem";
}
/**
 * ListIcon
 *
 * Used to render an icon beside the list item text
 */


var ListIcon = /*#__PURE__*/(0,forward_ref/* forwardRef */.G)((props, ref) => {
  var styles = (0,providers/* useStyles */.yK)();
  return /*#__PURE__*/react.createElement(icon/* Icon */.J, _extends({
    ref: ref,
    role: "presentation"
  }, props, {
    __css: styles.icon
  }));
});

if (assertion/* __DEV__ */.Ts) {
  ListIcon.displayName = "ListIcon";
}
//# sourceMappingURL=list.js.map
// EXTERNAL MODULE: ./node_modules/@chakra-ui/hooks/dist/esm/use-disclosure.js + 1 modules
var use_disclosure = __webpack_require__(4126);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/transition/dist/esm/slide-fade.js
var slide_fade = __webpack_require__(454);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/esm/text.js
var esm_text = __webpack_require__(4115);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/esm/box.js
var esm_box = __webpack_require__(8017);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/esm/flex.js
var flex = __webpack_require__(4096);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
// EXTERNAL MODULE: ./src/components/Image/index.ts + 1 modules
var Image = __webpack_require__(8331);
// EXTERNAL MODULE: ./src/components/Layout/index.ts + 11 modules
var Layout = __webpack_require__(8077);
// EXTERNAL MODULE: ./src/components/Button/index.ts + 1 modules
var Button = __webpack_require__(599);
// EXTERNAL MODULE: ./public/logo-101pay.png
var logo_101pay = __webpack_require__(1500);
;// CONCATENATED MODULE: ./public/products/bg-circle-1.png
/* harmony default export */ var bg_circle_1 = ({"src":"/_next/static/media/bg-circle-1.0d8e5a55.png","height":1072,"width":954,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAICAYAAAA1BOUGAAAAk0lEQVR42mWNUQrCQAxEM9uwIviliOD9r1Zt7VoFZVtomzFbxB8Hkkx4Q4K6eYkrBsgxBGzKYsZslKRNGqJWOAdAjWIFenBnZNSuzwdSKpIzIGChlBkBqpdbjhRZIKvc/oxp3fpPFP8vvaY8+twCYiwxWRtJgbaPsbfFTk60BL43g/tJu/sw+dp67c0YC6sC3qQ8P68/SpT5yYb9AAAAAElFTkSuQmCC"});
;// CONCATENATED MODULE: ./public/products/bg-circle-2.png
/* harmony default export */ var bg_circle_2 = ({"src":"/_next/static/media/bg-circle-2.9adf3454.png","height":739,"width":524,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAICAYAAADaxo44AAAAe0lEQVR42lWKuxKCUBDFsnsXx8LS1v//MQeVh874AAa5HlEqUiaxc/08uFEIlD/qEQ0wRdUOhSRmzN12c9xMWWUcLw8ZC4LJzQpgH6d6ECuUzWwbZXVfBTOQIM5Nv9olEqiLsn79xWJxdxtT8jaq6zBKxM+nZN075xuQv21hRizRSIMnAAAAAElFTkSuQmCC"});
;// CONCATENATED MODULE: ./public/products/bg-circle-3.png
/* harmony default export */ var bg_circle_3 = ({"src":"/_next/static/media/bg-circle-3.36f281c3.png","height":528,"width":418,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAICAYAAADaxo44AAAAgklEQVR42mXLwQ6CMBRE0ZnyBFcuNMb4/9+GCFVMiFYxacdW3XFWk5sM225C1riKe0fWeStG3e18fdVWuSOJSlICmGFjfgw76RsjSoIEINnJP5sSSRTCn7XDJGLJuiHMANckEgSCv5f1t3lMMR4kOBKSUND85fHOo897m6QVATnH8AEHzUK3h/ndNQAAAABJRU5ErkJggg=="});
;// CONCATENATED MODULE: ./public/products/bg-circle-mobile-1.png
/* harmony default export */ var bg_circle_mobile_1 = ({"src":"/_next/static/media/bg-circle-mobile-1.b9a7fba0.png","height":262,"width":198,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAICAYAAADaxo44AAAAfElEQVR42mWNOQ7CUBQDx48vQLRUcP+rhS0LBZAEspgvgWiYytJIHh0vt11Ia4Tm2b1NBbxS2Tw3NgaQyNv7cfIhFef7zBfjMaSFxDYVZWshDOgjJ6Flyg3DP+lUdRjARpIzC5suXz0QPxcKDRGqU9307WxWgCJogSswvAGSvEdEMNRiFQAAAABJRU5ErkJggg=="});
;// CONCATENATED MODULE: ./public/products/bg-circle-mobile-2.png
/* harmony default export */ var bg_circle_mobile_2 = ({"src":"/_next/static/media/bg-circle-mobile-2.44962233.png","height":209,"width":169,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAICAYAAADaxo44AAAAf0lEQVR42mXNwQqCQABF0fumoRZBUK36/08LTUwUjcgGZ17itrO7q6uqmS5xF05AKHYqxR0wx35MZxvbOIhDMbcllzrem1cGiY2zpCC4xsdzBjCAAOMC2se6nQz/YtN9DMgGCa/CNq/atyQMYKNVDkF9HMbvuGQfgbVJCgxA+gFE7EdP10KUHAAAAABJRU5ErkJggg=="});
// EXTERNAL MODULE: ./public/home/icon-play-circle.svg
var icon_play_circle = __webpack_require__(7809);
// EXTERNAL MODULE: ./public/home/image-bank-api.png
var image_bank_api = __webpack_require__(7719);
// EXTERNAL MODULE: ./public/home/image-neobank-sdk.png
var image_neobank_sdk = __webpack_require__(3050);
;// CONCATENATED MODULE: ./public/products/image-preview-101-pay.png
/* harmony default export */ var image_preview_101_pay = ({"src":"/_next/static/media/image-preview-101-pay.56372e8c.png","height":762,"width":404,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAICAYAAADeM14FAAAAk0lEQVR4nAGIAHf/AVIitfADBAQPChj6jaHCAnQBfVPT+w8TEASlms6ZraxIaAGEZ9r7L0f/BAD43e8YEv7UAZ5z2fgqUgkGIQwHAQLz3QABypfL/xk+EAAZKiT/6+vv+gHAmm2DFjlrXiUpJR7y8O75Af/58ADe6fOzHRwcTOLh6PgB////ANPT17EWGBVO6ujt8a1KQSaI5XVCAAAAAElFTkSuQmCC"});
;// CONCATENATED MODULE: ./public/products/image-preview-digibank.png
/* harmony default export */ var image_preview_digibank = ({"src":"/_next/static/media/image-preview-digibank.9a3ab352.png","height":414,"width":597,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAGCAYAAAD+Bd/7AAAAtElEQVR42m3HSwsBUQCG4bOm/C0/RsrK0lLJgpRY2Fsql42sRWJBCoXizL25NJczc2bOzMeUpbeexUsWi1lrPp10RsNemfzrsaq8zEPb2y8H9fwBlL6KPwVCnxewwMVjN/aNdU0ydk1V3zYU+9jXvFP3SWTN5CJFdj3vodMrYk9F5FD45hvcvgtCKQVjAW63OxyXIU9kAAs50gwR2W42VUmWFdswHB6GphDCSpLE4jxyRBJLH/OdkKG43RoXAAAAAElFTkSuQmCC"});
// EXTERNAL MODULE: ./public/home/logo-digibank.png
var logo_digibank = __webpack_require__(4881);
;// CONCATENATED MODULE: ./public/products/icon-check.svg
/* harmony default export */ var icon_check = ({"src":"/_next/static/media/icon-check.88287189.svg","height":24,"width":24});
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./src/containers/ModalWatchVideo/index.ts + 1 modules
var ModalWatchVideo = __webpack_require__(4314);
;// CONCATENATED MODULE: ./src/pages/products/index.tsx






















var boxes = [
    {
        title: "Discover",
        description: "Understand your vision for your business and products"
    },
    {
        title: "Partner and Co-Create",
        description: "Leverage our platform to rapidly evolve the products"
    },
    {
        title: "Launch",
        description: "Launch the product to market quickly and continue to refine"
    }, 
];
var productsPreviewData = [
    {
        key: "101-pay",
        link: "https://www.youtube.com/embed/q_0k8txaADs",
        logo: logo_101pay/* default */.Z,
        previewImage: image_preview_101_pay,
        imageAltText: "101Pay application development",
        description: "With 101 Pay, SMEs can manage their invoicing & banking in one app.",
        lists: [
            "Streamline the invoice generation process",
            "Help customers make timely payments",
            "Manage your finances better! ", 
        ]
    },
    {
        key: "digibank",
        link: "",
        logo: logo_digibank/* default */.Z,
        previewImage: image_preview_digibank,
        imageAltText: "DigiBank Webapp on desktop and mobile",
        description: "DigiBank is a pre-built solution that supports corporate and personal banking use cases.",
        lists: [
            "Available as a Platform as a Service (PaaS)",
            "Equipped with a range of web and mobile app front-ends",
            "Can be leveraged as a white-label solution", 
        ]
    }, 
];
var Products = function() {
    var router = (0,next_router.useRouter)();
    var ref = (0,use_disclosure/* useDisclosure */.q)(), isOpen = ref.isOpen, onOpen = ref.onOpen, onClose = ref.onClose;
    var ref1 = (0,react.useState)(""), urlVideo = ref1[0], setUrlVideo = ref1[1];
    var handleOpenWatchVideoModal = function(url) {
        setUrlVideo(url);
        onOpen();
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(head["default"], {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                    children: "101Digital | Products"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalWatchVideo/* default */.Z, {
                isOpen: isOpen,
                onClose: onClose,
                src: urlVideo
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(slide_fade/* SlideFade */.R, {
                in: true,
                offsetY: "50px",
                transition: {
                    enter: {
                        duration: 1
                    }
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm_text/* Text */.x, {
                    as: "h1",
                    textStyle: "h1",
                    textAlign: [
                        "center",
                        null,
                        null,
                        null,
                        null,
                        "left"
                    ],
                    display: "flex",
                    flexDir: [
                        "column",
                        null,
                        null,
                        null,
                        null,
                        "row"
                    ],
                    mt: [
                        "45px",
                        null,
                        null,
                        null,
                        null,
                        "132px"
                    ],
                    mb: [
                        "13px",
                        null,
                        null,
                        null,
                        null,
                        8
                    ],
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_text/* Text */.x, {
                            children: "Digital Platforms"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_text/* Text */.x, {
                            color: "secondary",
                            ml: 4,
                            children: "in Months"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_text/* Text */.x, {
                textStyle: "paragraphHighlighted",
                textAlign: [
                    "center",
                    null,
                    null,
                    null,
                    null,
                    "left"
                ],
                px: [
                    "61px",
                    null,
                    null,
                    null,
                    null,
                    0
                ],
                mb: [
                    "70px",
                    null,
                    null,
                    null,
                    null,
                    "200px"
                ],
                fontWeight: 300,
                children: "Reduce go-to-market timelines from years to months!"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm_box/* Box */.xu, {
                position: "relative",
                mx: "auto",
                maxW: "1000px",
                w: "100%",
                mb: [
                    "0",
                    null,
                    null,
                    "100px"
                ],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_box/* Box */.xu, {
                        pos: "absolute",
                        display: [
                            "none",
                            "block"
                        ],
                        right: "-459px",
                        top: "0",
                        zIndex: "-1",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                            src: bg_circle_1,
                            alt: "101Pay"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_box/* Box */.xu, {
                        pos: "absolute",
                        display: [
                            "block",
                            "none"
                        ],
                        left: "0",
                        top: "230px",
                        zIndex: "-1",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                            src: bg_circle_mobile_1,
                            alt: "101Pay"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_box/* Box */.xu, {
                        pos: "absolute",
                        display: [
                            "block",
                            "none"
                        ],
                        left: "0",
                        bottom: "280px",
                        zIndex: "-1",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                            src: bg_circle_mobile_2,
                            alt: "101Pay"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(flex/* Flex */.k, {
                        align: "center",
                        justify: "space-between",
                        flexDir: [
                            "column",
                            null,
                            null,
                            "row"
                        ],
                        px: "16px",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(slide_fade/* SlideFade */.R, {
                                in: true,
                                offsetX: "-200px",
                                transition: {
                                    enter: {
                                        duration: 1
                                    }
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm_box/* Box */.xu, {
                                    background: "#fff",
                                    flex: [
                                        "0 0 265px",
                                        null,
                                        null,
                                        "0 0 400px"
                                    ],
                                    maxW: [
                                        "265px",
                                        null,
                                        null,
                                        "400px"
                                    ],
                                    p: [
                                        "33px 27px",
                                        null,
                                        null,
                                        "50px 40px"
                                    ],
                                    borderRadius: "20px",
                                    boxShadow: "0px 0px 5px rgba(0, 0, 0, 0.25)",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_text/* Text */.x, {
                                            textStyle: "paragraph",
                                            fontSize: [
                                                "18px",
                                                null,
                                                null,
                                                "26px"
                                            ],
                                            color: "#14142B",
                                            mb: "10px",
                                            children: "Service"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm_text/* Text */.x, {
                                            textStyle: "h3",
                                            lineHeight: "1.3",
                                            fontSize: [
                                                "24px",
                                                null,
                                                null,
                                                "36px"
                                            ],
                                            fontWeight: "bold",
                                            color: "#102542",
                                            mb: "40px",
                                            children: [
                                                "Neobank SDK: ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {
                                                }),
                                                " Neobank as a Service"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_box/* Box */.xu, {
                                            w: "100%",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                                src: image_neobank_sdk/* default */.Z,
                                                alt: ""
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(slide_fade/* SlideFade */.R, {
                                in: true,
                                offsetY: "50px",
                                transition: {
                                    enter: {
                                        duration: 1
                                    }
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm_box/* Box */.xu, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_text/* Text */.x, {
                                            maxW: "490px",
                                            textStyle: "paragraph",
                                            mb: "28px",
                                            fontSize: [
                                                "14px",
                                                null,
                                                null,
                                                "21px"
                                            ],
                                            fontWeight: "300",
                                            textAlign: [
                                                "center",
                                                null,
                                                null,
                                                "left"
                                            ],
                                            mt: [
                                                "40px",
                                                null,
                                                null,
                                                "unset"
                                            ],
                                            px: [
                                                "16px",
                                                null,
                                                null,
                                                "0"
                                            ],
                                            lineHeight: "1.3",
                                            children: "Design, build and launch a neo bank at reduced cost and risk with a single technology offering. Work with a cloud-based infrastructure, a rich set of APIs, and secured DevOps to enable seamless digital experiences."
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(flex/* Flex */.k, {
                                            align: "center",
                                            justify: [
                                                "center",
                                                null,
                                                null,
                                                "left"
                                            ],
                                            mb: [
                                                "80px",
                                                null,
                                                null,
                                                "unset"
                                            ],
                                            cursor: "pointer",
                                            onClick: function() {
                                                return handleOpenWatchVideoModal("https://www.youtube.com/embed/OSerkQYuzjg");
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_box/* Box */.xu, {
                                                    w: [
                                                        "16px",
                                                        null,
                                                        null,
                                                        "auto"
                                                    ],
                                                    height: [
                                                        "20px",
                                                        null,
                                                        null,
                                                        "34px"
                                                    ],
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                                        src: icon_play_circle/* default */.Z,
                                                        alt: ""
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_text/* Text */.x, {
                                                    textStyle: "paragraph",
                                                    fontSize: [
                                                        "12px",
                                                        null,
                                                        null,
                                                        "24px"
                                                    ],
                                                    ml: [
                                                        "10px",
                                                        null,
                                                        null,
                                                        "24px"
                                                    ],
                                                    color: "#2D4FA7",
                                                    fontWeight: "bold",
                                                    children: "Watch intro"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_box/* Box */.xu, {
                        height: "1px",
                        background: "rgba(0, 0, 0, 0.15)",
                        width: "80%",
                        mx: "auto",
                        my: "75px",
                        display: [
                            "none",
                            null,
                            null,
                            "block"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(flex/* Flex */.k, {
                        align: "center",
                        justify: "space-between",
                        flexDir: [
                            "column",
                            null,
                            null,
                            "row-reverse"
                        ],
                        px: "16px",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(slide_fade/* SlideFade */.R, {
                                in: true,
                                offsetX: "200px",
                                transition: {
                                    enter: {
                                        duration: 1
                                    }
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm_box/* Box */.xu, {
                                    background: "#fff",
                                    flex: [
                                        "0 0 265px",
                                        null,
                                        null,
                                        "0 0 400px"
                                    ],
                                    maxW: [
                                        "265px",
                                        null,
                                        null,
                                        "400px"
                                    ],
                                    p: [
                                        "33px 27px",
                                        null,
                                        null,
                                        "50px 40px"
                                    ],
                                    borderRadius: "20px",
                                    boxShadow: "0px 0px 5px rgba(0, 0, 0, 0.25)",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_text/* Text */.x, {
                                            textStyle: "paragraph",
                                            fontSize: [
                                                "18px",
                                                null,
                                                null,
                                                "26px"
                                            ],
                                            color: "#14142B",
                                            mb: "10px",
                                            children: "Service"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm_text/* Text */.x, {
                                            textStyle: "h3",
                                            lineHeight: "1.3",
                                            fontSize: [
                                                "24px",
                                                null,
                                                null,
                                                "36px"
                                            ],
                                            fontWeight: "bold",
                                            color: "#102542",
                                            mb: "40px",
                                            children: [
                                                "Bank-API: ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {
                                                }),
                                                " Open Banking as a Service"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_box/* Box */.xu, {
                                            w: "100%",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                                src: image_bank_api/* default */.Z,
                                                alt: ""
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(slide_fade/* SlideFade */.R, {
                                in: true,
                                offsetY: "50px",
                                transition: {
                                    enter: {
                                        duration: 1
                                    }
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm_box/* Box */.xu, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_text/* Text */.x, {
                                            maxW: "490px",
                                            textStyle: "paragraph",
                                            mb: "28px",
                                            fontSize: [
                                                "14px",
                                                null,
                                                null,
                                                "21px"
                                            ],
                                            fontWeight: "300",
                                            textAlign: [
                                                "center",
                                                null,
                                                null,
                                                "left"
                                            ],
                                            mt: [
                                                "40px",
                                                null,
                                                null,
                                                "unset"
                                            ],
                                            px: [
                                                "16px",
                                                null,
                                                null,
                                                "0"
                                            ],
                                            lineHeight: "1.3",
                                            children: "Experience the benefits of open banking without the extended timelines and complicated backend tasks. Gain free access to ready-made APIs, apps, and a customizable portal, to onboard your FinTech partners with ease!"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(flex/* Flex */.k, {
                                            align: "center",
                                            justify: [
                                                "center",
                                                null,
                                                null,
                                                "left"
                                            ],
                                            mb: [
                                                "80px",
                                                null,
                                                null,
                                                "unset"
                                            ],
                                            cursor: "pointer",
                                            onClick: function() {
                                                return handleOpenWatchVideoModal("https://www.youtube.com/embed/NCyFlX9AFuQ");
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_box/* Box */.xu, {
                                                    w: [
                                                        "16px",
                                                        null,
                                                        null,
                                                        "auto"
                                                    ],
                                                    height: [
                                                        "20px",
                                                        null,
                                                        null,
                                                        "34px"
                                                    ],
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                                        src: icon_play_circle/* default */.Z,
                                                        alt: ""
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_text/* Text */.x, {
                                                    textStyle: "paragraph",
                                                    fontSize: [
                                                        "12px",
                                                        null,
                                                        null,
                                                        "24px"
                                                    ],
                                                    ml: [
                                                        "10px",
                                                        null,
                                                        null,
                                                        "24px"
                                                    ],
                                                    color: "#2D4FA7",
                                                    fontWeight: "bold",
                                                    children: "Watch intro"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_box/* Box */.xu, {
                pos: "relative",
                w: "100%",
                maxW: "1200px",
                p: [
                    "0px",
                    null,
                    null,
                    null,
                    "0 0 200px"
                ],
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(flex/* Flex */.k, {
                    justify: [
                        "center",
                        null,
                        null,
                        "space-between"
                    ],
                    flexDir: [
                        "column",
                        null,
                        null,
                        "row"
                    ],
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_box/* Box */.xu, {
                            pos: "absolute",
                            width: [
                                "290px",
                                "auto"
                            ],
                            left: [
                                "-135px",
                                "-359px"
                            ],
                            top: [
                                "62%",
                                "0"
                            ],
                            zIndex: "-1",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                src: bg_circle_2,
                                alt: "101Pay"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_box/* Box */.xu, {
                            pos: "absolute",
                            width: [
                                "209px",
                                "auto"
                            ],
                            right: [
                                "-50px",
                                "-359px"
                            ],
                            bottom: [
                                "85%",
                                "160px"
                            ],
                            zIndex: "-1",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                src: bg_circle_3,
                                alt: "101Pay"
                            })
                        }),
                        productsPreviewData.map(function(item, index) {
                            /*#__PURE__*/ return (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(flex/* Flex */.k, {
                                        flexDir: "column",
                                        mb: [
                                            "70px",
                                            null,
                                            null,
                                            "unset"
                                        ],
                                        px: "16px",
                                        children: [
                                            item.key === "digibank" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_box/* Box */.xu, {
                                                        mx: "auto",
                                                        mt: [
                                                            "-22px"
                                                        ],
                                                        maxW: [
                                                            "250px",
                                                            null,
                                                            null,
                                                            "470px"
                                                        ],
                                                        mb: [
                                                            "0",
                                                            null,
                                                            null,
                                                            "80px"
                                                        ],
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                                            src: item.logo,
                                                            alt: "101Pay"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_box/* Box */.xu, {
                                                        order: [
                                                            3,
                                                            null,
                                                            null,
                                                            "unset"
                                                        ],
                                                        maxW: [
                                                            "330px",
                                                            null,
                                                            null,
                                                            "593px"
                                                        ],
                                                        px: "16px",
                                                        w: [
                                                            "100%",
                                                            null,
                                                            null,
                                                            "unset"
                                                        ],
                                                        mx: [
                                                            "auto",
                                                            null,
                                                            null,
                                                            "unset"
                                                        ],
                                                        mt: [
                                                            "70px",
                                                            null,
                                                            null,
                                                            "30px"
                                                        ],
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                                            src: item.previewImage,
                                                            alt: item.imageAltText
                                                        })
                                                    })
                                                ]
                                            }),
                                            item.key === "101-pay" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_box/* Box */.xu, {
                                                        maxW: [
                                                            "142px",
                                                            null,
                                                            null,
                                                            "260px"
                                                        ],
                                                        mx: "auto",
                                                        mb: [
                                                            "0",
                                                            null,
                                                            null,
                                                            "80px"
                                                        ],
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                                            src: item.logo,
                                                            alt: "101Pay"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_box/* Box */.xu, {
                                                        order: [
                                                            3,
                                                            null,
                                                            null,
                                                            "unset"
                                                        ],
                                                        maxW: [
                                                            "200px",
                                                            null,
                                                            null,
                                                            "268px"
                                                        ],
                                                        mx: [
                                                            "auto"
                                                        ],
                                                        mt: [
                                                            "70px",
                                                            null,
                                                            null,
                                                            "0"
                                                        ],
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                                            src: item.previewImage,
                                                            alt: item.imageAltText
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_text/* Text */.x, {
                                                color: "#777",
                                                fontSize: [
                                                    "14px",
                                                    null,
                                                    null,
                                                    "21px"
                                                ],
                                                fontWeight: "300",
                                                maxW: [
                                                    "300px",
                                                    null,
                                                    null,
                                                    item.key === "digibank" ? "555px" : "490px", 
                                                ],
                                                mt: [
                                                    "0",
                                                    null,
                                                    null,
                                                    item.key === "digibank" ? "126px" : "50px", 
                                                ],
                                                mx: [
                                                    "auto",
                                                    null,
                                                    null,
                                                    "unset"
                                                ],
                                                mb: [
                                                    "20px",
                                                    null,
                                                    null,
                                                    "unset"
                                                ],
                                                textAlign: [
                                                    "center",
                                                    null,
                                                    null,
                                                    "left"
                                                ],
                                                order: [
                                                    1,
                                                    null,
                                                    null,
                                                    "unset"
                                                ],
                                                children: item.description
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(UnorderedList, {
                                                order: [
                                                    4,
                                                    null,
                                                    null,
                                                    "unset"
                                                ],
                                                listStyleType: "none",
                                                margin: [
                                                    "40px auto 0px",
                                                    null,
                                                    null,
                                                    "40px 0 28px"
                                                ],
                                                maxW: [
                                                    "340px",
                                                    null,
                                                    null,
                                                    "unset"
                                                ],
                                                px: [
                                                    "16px",
                                                    null,
                                                    null,
                                                    "unset"
                                                ],
                                                children: item.lists.map(function(list, indexList) {
                                                    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(ListItem, {
                                                        display: "flex",
                                                        alignItems: "center",
                                                        color: "#2D4FA7",
                                                        fontSize: [
                                                            "14px",
                                                            null,
                                                            null,
                                                            "24px"
                                                        ],
                                                        mb: "12px",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_box/* Box */.xu, {
                                                                mr: "12px",
                                                                flex: "0 0 24px",
                                                                maxW: "24px",
                                                                height: "28px",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                                                    src: icon_check,
                                                                    alt: ""
                                                                })
                                                            }),
                                                            list
                                                        ]
                                                    }, indexList);
                                                })
                                            }),
                                            item.link && /*#__PURE__*/ (0,jsx_runtime.jsxs)(flex/* Flex */.k, {
                                                align: "center",
                                                justify: [
                                                    "center",
                                                    null,
                                                    null,
                                                    "left"
                                                ],
                                                mb: [
                                                    "0",
                                                    null,
                                                    null,
                                                    "unset"
                                                ],
                                                order: [
                                                    2,
                                                    null,
                                                    null,
                                                    "unset"
                                                ],
                                                cursor: "pointer",
                                                onClick: function() {
                                                    return handleOpenWatchVideoModal(item.link);
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_box/* Box */.xu, {
                                                        w: [
                                                            "16px",
                                                            null,
                                                            null,
                                                            "auto"
                                                        ],
                                                        height: [
                                                            "18px",
                                                            null,
                                                            null,
                                                            "35px"
                                                        ],
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                                            src: icon_play_circle/* default */.Z,
                                                            alt: ""
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_text/* Text */.x, {
                                                        textStyle: "paragraph",
                                                        fontSize: [
                                                            "12px",
                                                            null,
                                                            null,
                                                            "24px"
                                                        ],
                                                        ml: [
                                                            "10px",
                                                            null,
                                                            null,
                                                            "24px"
                                                        ],
                                                        color: "#2D4FA7",
                                                        fontWeight: "bold",
                                                        children: "Watch intro"
                                                    })
                                                ]
                                            })
                                        ]
                                    }, index),
                                    index === 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_box/* Box */.xu, {
                                        minheight: "900px",
                                        background: "rgba(0, 0, 0, 0.15)",
                                        width: "1px",
                                        display: [
                                            "none",
                                            null,
                                            null,
                                            "block"
                                        ]
                                    })
                                ]
                            });
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_text/* Text */.x, {
                as: "h2",
                textStyle: "h2",
                fontSize: [
                    "18px",
                    null,
                    null,
                    null,
                    null,
                    "48px"
                ],
                fontWeight: "300",
                mb: [
                    "20px",
                    null,
                    null,
                    null,
                    null,
                    "27px"
                ],
                children: "Partnership Approach"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_text/* Text */.x, {
                textStyle: "paragraph",
                textAlign: "center",
                fontWeight: "300",
                mb: [
                    "54.66px",
                    null,
                    null,
                    null,
                    null,
                    "108px"
                ],
                children: "Three simple steps to create the perfect digital products!"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(flex/* Flex */.k, {
                flexDir: [
                    "column",
                    null,
                    null,
                    null,
                    null,
                    "row"
                ],
                maxWidth: "1163px",
                width: "100%",
                mb: [
                    "56.25px",
                    null,
                    null,
                    null,
                    null,
                    "72px"
                ],
                px: [
                    "66px",
                    null,
                    null,
                    null,
                    null,
                    "16px"
                ],
                children: boxes.map(function(box, index) {
                    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(esm_box/* Box */.xu, {
                        padding: [
                            "30.79px 0px 23.37px",
                            null,
                            null,
                            null,
                            null,
                            "46px 0px 36px", 
                        ],
                        flex: [
                            "0 1 auto",
                            null,
                            null,
                            null,
                            null,
                            "1"
                        ],
                        borderRadius: [
                            "6px",
                            null,
                            null,
                            null,
                            null,
                            "10px"
                        ],
                        border: [
                            "none",
                            null,
                            null,
                            null,
                            null,
                            "1px solid #2D4FA7"
                        ],
                        boxShadow: [
                            "0px 0px 12px rgba(0, 0, 0, 0.1)",
                            null,
                            null,
                            null,
                            null,
                            "none", 
                        ],
                        pos: "relative",
                        mx: [
                            "0px",
                            null,
                            null,
                            null,
                            null,
                            index === 1 ? "16px" : 0
                        ],
                        my: [
                            index === 1 ? "54px" : 0,
                            null,
                            null,
                            null,
                            null,
                            0
                        ],
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(flex/* Flex */.k, {
                                w: [
                                    "49.46px",
                                    null,
                                    null,
                                    null,
                                    null,
                                    "76px"
                                ],
                                h: [
                                    "49.46px",
                                    null,
                                    null,
                                    null,
                                    null,
                                    "76px"
                                ],
                                borderRadius: "50%",
                                bgColor: "white",
                                fontSize: [
                                    "14px",
                                    null,
                                    null,
                                    null,
                                    null,
                                    "36px"
                                ],
                                lineHeight: [
                                    "15.87px",
                                    null,
                                    null,
                                    null,
                                    null,
                                    "24.13px"
                                ],
                                fontWeight: "700",
                                color: "primary",
                                justify: "center",
                                alignItems: "center",
                                pos: "absolute",
                                top: "0",
                                left: "50%",
                                transform: "translate(-50%, -50%)",
                                boxShadow: [
                                    "0px 0px 2.6313px rgba(0, 0, 0, 0.25)",
                                    null,
                                    null,
                                    null,
                                    null,
                                    "0px 0px 4px rgba(0, 0, 0, 0.25)", 
                                ],
                                children: index + 1
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_text/* Text */.x, {
                                color: "secondary",
                                textAlign: "center",
                                fontSize: [
                                    "14px",
                                    null,
                                    null,
                                    null,
                                    null,
                                    "23.12px"
                                ],
                                lineHeight: [
                                    "22.22px",
                                    null,
                                    null,
                                    null,
                                    null,
                                    "33.78px"
                                ],
                                mb: [
                                    "11.62px",
                                    null,
                                    null,
                                    null,
                                    null,
                                    "16px"
                                ],
                                fontWeight: "700",
                                children: box.title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_text/* Text */.x, {
                                color: "primary",
                                textAlign: "center",
                                fontSize: [
                                    "14px",
                                    null,
                                    null,
                                    null,
                                    null,
                                    "22px"
                                ],
                                lineHeight: [
                                    "19.73px",
                                    null,
                                    null,
                                    null,
                                    null,
                                    "30px"
                                ],
                                fontWeight: "400",
                                px: [
                                    "22px",
                                    null,
                                    null,
                                    null,
                                    null,
                                    "28px"
                                ],
                                children: box.description
                            })
                        ]
                    }, box.title);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                href: "#",
                w: [
                    "calc(100% - 84px)",
                    null,
                    null,
                    null,
                    null,
                    "100%"
                ],
                mx: "auto",
                maxW: "444px",
                mb: [
                    "94px",
                    null,
                    null,
                    null,
                    null,
                    "99px"
                ],
                onClick: function() {
                    return router.push("/approach");
                },
                children: "Understand our approach"
            })
        ]
    }));
};
/* harmony default export */ var products = (Products);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [425,454,325,77,774,888,179], function() { return __webpack_exec__(719); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);